import React from "react";
import { Animate, Button, Callout, CircularProgress } from "@sscs/ui";
import { LoginContentWrapper, LoginLayout } from "Components";
import { VerificationStatus } from "Types";

export type VerifySSOChangesProps = {
  onClose: () => void;
  verificationStatus: VerificationStatus;
};

type WrapperProps = {
  children: React.ReactElement;
  animationKey: string;
};

const Wrapper = ({
  children,
  animationKey,
}: WrapperProps): React.JSX.Element => {
  return (
    <LoginLayout>
      <Animate.SimpleTransition animationKey={animationKey}>
        {children}
      </Animate.SimpleTransition>
    </LoginLayout>
  );
};

const VerifySSOChangesLayout = ({
  onClose,
  verificationStatus,
}: VerifySSOChangesProps): React.JSX.Element => {
  if (verificationStatus === "status-unknown") {
    return (
      <Wrapper animationKey={verificationStatus}>
        <LoginContentWrapper title="Verifying SSO changes">
          <CircularProgress size="large" />
        </LoginContentWrapper>
      </Wrapper>
    );
  } else if (verificationStatus === "status-error") {
    return (
      <Wrapper animationKey={verificationStatus}>
        <LoginContentWrapper title="Verification unsuccessful">
          <Callout type="error" title="Changes reverted">
            Your SSO changes have been rolled back.
          </Callout>
          <Button onClick={onClose} color="secondary">
            Close
          </Button>
        </LoginContentWrapper>
      </Wrapper>
    );
  } else if (verificationStatus === "status-verified") {
    return (
      <Wrapper animationKey={verificationStatus}>
        <LoginContentWrapper title="Verification successful">
          <Callout type="success" title="Changes saved">
            Your SSO changes have been verified and saved.
          </Callout>
          <Button onClick={onClose} color="primary">
            OK
          </Button>
        </LoginContentWrapper>
      </Wrapper>
    );
  } else {
    return <></>;
  }
};

export default VerifySSOChangesLayout;
